import { formatMoney, formatMoneyCompact, type Paise } from '@/shared/utils/money';

export interface MoneyProps {
  /** Amount in integer paise. Never rupees. Never a float. */
  amount: Paise;
  /** Skip decimals; good for big KPI tiles. */
  compact?: boolean;
  'data-testid'?: string;
  className?: string;
}

export function Money({ amount, compact = false, className, ...rest }: MoneyProps) {
  return (
    <span className={className} {...rest}>
      {compact ? formatMoneyCompact(amount) : formatMoney(amount)}
    </span>
  );
}
